<abc-drawer
  fxFill
  class="drawer"
  fxLayout="column"
  position="before"
  [closeOnOutsideClick]="shaderEnabled"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [maxSize]="maxMenuSize"
  [shading]="shaderEnabled"
  (onOptionChanged)="onDrawerOptionChanged($event)"
  [(opened)]="menuOpened"
>
  @if (visiblityDrawer) {
    <div id="menu" fxLayout="column" content="abcDrawerContainer">
      <abc-toolbar #abcToolbar fxLayout="row" id="navigation-header">
        <dxi-item location="left" cssClass="header-title" (click)="toggleMenu($event)">
          <img
            [class]="menuOpened ? 'menu-open-logo' : 'menu-closed-logo'"
            [src]="menuOpened ? logoIcon : logoMiniatureIcon"
            [title]="menuOpened ? navigationCollapseTooltipText : navigationExpandTooltipText"
          />
        </dxi-item>
      </abc-toolbar>
      <div class="menu-container" fxLayout="column" fxFlex="calc(100% - 150px)">
        @if (showNavigationBorder) {
          <div class="border-bottom" fxFlex="13">
            <div
              fxLayout="row"
              fxLayoutAlign="space-evenly center"
              [ngClass]="!menuOpened ? 'close-menu-tree-list' : 'open-menu-tree-list'"
              fxFill
            >
              <div fxLayout="row" fxLayoutAlign="center" fxFlex="15">
                <img class="company-logo" src="{{ logoNavigationBorder }}" (click)="onMenuItemClick($event)" />
              </div>
              <div class="text-container" fxFlex="85">
                <span class="layout-title-nav-style"> {{ navigationBorderFirstTitle }}</span>
                <span class="layout-title-nav-style">{{ navigationBorderSecondTitle }}</span>
              </div>
            </div>
          </div>
        }
        <div class="menu-container">
          <ng-content select="[locationMenu]"></ng-content>
          <abc-tree
            #treeView
            class="menu-treeview"
            [ngStyle]="{
              height: locationMenu ? 'calc(100% - 150px)' : 'calc(100% - 50px)',
              width: showTreeViewScrollContainer ? null : '100%',
            }"
            [ngClass]="{
              'open-menu-tree-list': menuOpened,
              'close-menu-tree-list': !menuOpened,
            }"
            [items]="navigationItems"
            keyExpr="path"
            selectionMode="single"
            [focusStateEnabled]="false"
            [displayExpr]="'text'"
            [itemsExpr]="'items'"
            expandEvent="click"
            whiteSpace="normal"
            (onItemClick)="onMenuItemClick($event)"
          >
          </abc-tree>
        </div>
        <div fxLayout="column" fxLayoutAlign="center" [fxFlex]="flexValue">
          @if (showLogout) {
            <div
              fxLayout="row"
              fxLayoutAlign="space-evenly center"
              [ngClass]="!menuOpened ? 'close-menu-tree-list' : 'open-menu-tree-list'"
            >
              <div fxLayout="row" fxLayoutAlign="center" fxFlex="15">
                <img class="company-logo" src="{{ logoutIcon }}" (click)="logout()" />
              </div>
              <div class="text-container" fxFlex="85">
                <span class="layout-title-nav-style" (click)="logout()">{{ logoutText }}</span>
              </div>
            </div>
          }
          @if (showToggleButton) {
            <div
              [ngClass]="!menuOpened ? 'toggle-menu-btn-container-closed' : 'toggle-menu-btn-container-opened'"
              (click)="toggleMenu($event)"
            >
              @if (menuOpened) {
                <img class="toggle-menu-button" src="assets/images/PageMenu_close.svg" />
              }
              @if (!menuOpened) {
                <img class="toggle-menu-button" src="assets/images/page-menu-open.svg" />
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

  <div fxLayout="column" class="app-container" id="container" content="abcDrawerContent">
    <header fxLayout="row" id="header">
      <abc-toolbar class="header-toolbar" fxLayout="column" fxLayoutAlign="center center">
        <dxi-item location="before">
          @if (showBackButton) {
            <dx-button mat-button class="menu-button" (click)="goBack()">
              <img class="menu-open" src="assets/images/arrow-left.svg" />
            </dx-button>
          }
          @if (showMenuToggleButton) {
            <button mat-button class="menu-button" (click)="toggleMenu($event)">
              <mat-icon class="menu-open-icon"> {{ 'menu' }}</mat-icon>
            </button>
          }
        </dxi-item>
        <dxi-item location="before">
          <div class="border-left"></div>
        </dxi-item>

        @if (_showMobileToggleIcon) {
          <dxi-item class="mobile-toggle" location="before">
            <div fxLayout="row" fxLayoutAlign="start center">
              <img [src]="logoMiniatureIcon" (click)="toggleMenu($event)" />
            </div>
          </dxi-item>
        }

        @if (visiblityLogo) {
          <dxi-item location="before">
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-icon class="logo-icon" [svgIcon]="firstLogo"></mat-icon>
              <!-- <mat-icon class="logo-icon" [svgIcon]="secondLogo"></mat-icon> -->
            </div>
          </dxi-item>
        }

        <dxi-item cssClass="title-style" location="before" style="width: 100%">
          <div fxLayout="column" fxLayoutAlign="center">
            <div fxLayout="row" fxLayoutAlign="flex-start center">
              <span class="address-style">{{ toolBarFirstTitle }}</span>
              <ng-content select="[toolBarFirstTitle]"></ng-content>
            </div>
            <div fxLayout="row" fxLayoutAlign="flex-start center">
              <span class="layout-title-style">{{ toolBarSecondTitle }}</span>
              <ng-content select="[toolBarSecondTitle]"></ng-content>
            </div>
          </div>
        </dxi-item>
        <dxi-item location="after" fxLayout="row" fxLayoutAlign="space-evenly">
          <ng-content select="[headerIcons]"></ng-content>
          <div class="user-info">
            @if (userNotification) {
              <img class="user-notification" src="assets/images/notification.svg" />
            }

            @if (userMessage) {
              <img class="user-message" src="assets/images/comment.svg" />
            }

            <div class="avatar-container" [ngClass]="{ 'c-pointer': customAvatar }" (click)="onAvatarClick()">
              <div [ngClass]="{ 'avatar-ring': userAvatar && customAvatar }">
                <!-- img id is being (used / queried) in some projects -->

                @if (defaultAvatar || userAvatar?.length) {
                  <img
                    #avatarImage
                    id="avatar-img"
                    class="avatar-img"
                    [ngClass]="{ 'full-size': userAvatar == null || !customAvatar }"
                    [src]="userAvatar ? 'data:image/png;base64,' + userAvatar : defaultAvatar"
                    alt="User Avatar"
                  />
                }
              </div>
              @if (customAvatar) {
                <div class="avatar-camera-icon">
                  <i class="dx-icon dx-icon-photooutline"></i>
                </div>
              }
            </div>

            <div class="user-name-bloc">
              <p class="user-name">{{ currentUserName }}</p>
              <p class="user-function">{{ userFunction }}</p>
            </div>
            <mat-icon
              class="context-menu-icon custom-profile-context-menu"
              [svgIcon]="res.svgName('ArrowDown-Image')"
            ></mat-icon>
          </div>
        </dxi-item>
      </abc-toolbar>
      <abc-context-menu
        #contextMenu
        class="custom-context-menu"
        target=".custom-profile-context-menu"
        showEvent="dxclick"
        [items]="contextMenuItems"
      >
      </abc-context-menu>
    </header>
    <ng-content> </ng-content>
  </div>
</abc-drawer>
